export default __webpack_public_path__ + "static/media/no-client.f503c85d.svg";